import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Chip, Theme, useTheme } from "@mui/material/index";
import { HistoryRounded } from "@mui/icons-material";
import { CBCustomerState, IFormValues } from "../../types";
import { chipActionIcon, chipActionSx } from "./chipAction";

interface CustomerBaseStateProps {
    /** Se presente, la chip mostra in coda l'azione che apre lo storico dello stato cliente. */
    onShowHistory?: () => void
}

const CustomerBaseState = ({ onShowHistory }: CustomerBaseStateProps) => {

    const theme = useTheme();
    const { t } = useTranslation("customerbase");
    const { control } = useFormContext<IFormValues>();
    const customerStateWatch = useWatch<IFormValues, 'cbDetails.customerState'>({name: "cbDetails.customerState"});

    const getChipColor = (state: string | null, theme: Theme) => {
        var color = theme.palette.grey.A400;

        if(!!state) {
            switch(state) {
                case CBCustomerState.ACTIVE:
                    color = theme.palette.success.main;
                    break;
                case CBCustomerState.BLOCKED:
                    color = theme.palette.error.main;
                    break;
                case CBCustomerState.SUSPENDED:
                    color = theme.palette.warning.main;
                    break;
                case CBCustomerState.WITHDRAWN:
                    color = theme.palette.grey.A400;
                    break;
                default:
                    color = theme.palette.grey.A400
            }
        }

        return color;

    }

    return (
        <>
            {!!customerStateWatch && 
                <Controller
                    control={control}
                    name="cbDetails.customerState"
                    render={({field}) => (
                        <Chip
                            label={t(`customerState.${field.value}`)}
                            onDelete={onShowHistory}
                            deleteIcon={chipActionIcon(t("customerStateHistoryTooltip"), <HistoryRounded />)}
                            sx={{color: "white", backgroundColor: getChipColor(field.value, theme), ...chipActionSx()}}
                        />
                    )}             
                />
            }
        </>
    );

}

export default CustomerBaseState;